import { TFunction } from 'i18next';
import { OBJECT_TYPE_HISTORY, TKeys } from 'utils/enums';

export interface PrintSettingState {
    columnTable: DataGridColumn[];
    sortColumn: number;
    ascending: boolean;
    dialogStatus: { status: boolean };
    filter: Record<string, any>;
    page: number;
    dataTable: IPrintSettingTable[];
    selectItem?: IPrintSettingTable;
    rowOrder: number[];
    paginateMetaData: Pagination;
    searchConditions: Record<string, any>;
    files: FileItem[];
    presignedUrl?: string;
}

export interface IPrintSettingTable {
    type: string;
    file?: File;
    fileName?: string;
    presignedUrl?: string;
    updateAt: string;
    comment: string;
}

export interface IPrintSettingRequest {
    onClose: () => void;
    onSubmit: (data: IPrintSettingTable) => void;
    data: IPrintSettingTable;
}

export interface IPrintSettingDialogProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: IPrintSettingTable) => void;
    data: IPrintSettingTable;
}

export interface FileItem {
    key: string;
    last_modified: string;
    size: number;
    url: string;
    comment: string;
}

export interface FileResponse {
    files: FileItem[];
    presignedUrl: string;
}

export enum FileNamePrint {
    USER_LABEL = 'user_label.spfmtz',
    COMMON = 'common.spfmtz',
    INSTALLATION = 'installation.spfmtz',
    COLLECTION = 'collection.spfmtz',
    IMPORT = 'import.spfmtz',
    PROCESS_OUTPUT = 'processoutput.spfmtz',
    CONTAINER = 'returnable_label_with_comp.spfmtz',
}

export const TABLE_PRINT_SETTING_DEFAULT: DataGridColumn[] = [
    { title: TKeys.LBL240001, titleAlign: 'left', field: 'type' },
    { title: TKeys.LBL240002, titleAlign: 'left', field: 'updateAt' },
    { title: TKeys.LBL240003, titleAlign: 'left', field: 'comment' },
];

export const TABLE_PRINT_SETTING_DEFAULT_DATA: IPrintSettingTable[] = [
    {
        type: TKeys.LBL240004,
        updateAt: '',
        comment: '',
        fileName: FileNamePrint.USER_LABEL,
    },
    {
        type: TKeys.LBL240005,
        updateAt: '',
        comment: '',
        fileName: FileNamePrint.COMMON,
    },
    {
        type: TKeys.LBL240006,
        updateAt: '',
        comment: '',
        fileName: FileNamePrint.INSTALLATION,
    },
    {
        type: TKeys.LBL240007,
        updateAt: '',
        comment: '',
        fileName: FileNamePrint.COLLECTION,
    },
    {
        type: TKeys.LBL240008,
        updateAt: '',
        comment: '',
        fileName: FileNamePrint.IMPORT,
    },
    {
        type: TKeys.LBL240009,
        updateAt: '',
        comment: '',
        fileName: FileNamePrint.PROCESS_OUTPUT,
    },
];

export const getColumnNameMap = (tf: TFunction): Record<number, Record<string, string>> => {
    return {
        [OBJECT_TYPE_HISTORY.CONTENT_MASTER]: {
            type: tf(TKeys.LBL240001),
            update_at: tf(TKeys.LBL240002),
            comment: tf(TKeys.LBL240003),
        },
    };
};

export enum PrintFormatType {
    user = 'user',
    common = 'common',
    installation = 'installation',
    collection = 'collection',
    receiving = 'receiving',
    processOutput = 'processOutput',
    container = 'container',
}

export function getPrintFormatLayout(type: PrintFormatType): string {
    switch (type) {
        case PrintFormatType.user:
            return FileNamePrint.USER_LABEL;
        case PrintFormatType.common:
            return FileNamePrint.COMMON;
        case PrintFormatType.installation:
            return FileNamePrint.INSTALLATION;
        case PrintFormatType.collection:
            return FileNamePrint.COLLECTION;
        case PrintFormatType.receiving:
            return FileNamePrint.IMPORT;
        case PrintFormatType.processOutput:
            return FileNamePrint.PROCESS_OUTPUT;
        case PrintFormatType.container:
            return FileNamePrint.CONTAINER;
        default:
            throw new Error(`Unknown PrintFormatType: ${type}`);
    }
}
